export const loadAssetOptions = [
  { label: '蒙西电厂', value: '1' },
  { label: '蒙西冶炼', value: '2' },
];

export const getLoadAssetLabel = (value?: string | number) =>
  loadAssetOptions.find(item => String(item.value) === String(value))?.label;
